import pino from "pino";

export const logger = pino(
  // `pino-pretty` runs in a worker thread, which bun's test runner cannot spawn
  // (`port.on is not a function` from thread-stream). Tests get plain JSON on
  // stdout instead -- same log lines, no worker.
  process.env.NODE_ENV === "test"
    ? {}
    : {
        transport: {
          target: "pino-pretty",
        },
      },
);
